
(() => {
    const DELAY    = 4000;   // autoplay interval
    const DURATION = 480;    // glide duration (ms)
    const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

    const init = (track) => {
      if (track.dataset.promoInit) return;
      track.dataset.promoInit = '1';

      const cards   = () => [...track.children];
      const offsets = () => {
        const base = track.getBoundingClientRect().left - track.scrollLeft;
        return cards().map(c => c.getBoundingClientRect().left - base);
      };
      const clamp = (i) => Math.max(0, Math.min(cards().length - 1, i));

      let index = 0, animating = false, raf = null;

      /* smooth eased glide */
      const animateTo = (left, dur = DURATION) => {
        cancelAnimationFrame(raf);
        const from = track.scrollLeft, dist = left - from;
        if (Math.abs(dist) < 1) return;
        const t0 = performance.now();
        track.style.scrollSnapType = 'none';     // snap fights a manual animation
        animating = true;
        const step = (now) => {
          const p = Math.min(1, (now - t0) / dur);
          const e = 1 - Math.pow(1 - p, 3);      // easeOutCubic
          track.scrollLeft = from + dist * e;
          if (p < 1) { raf = requestAnimationFrame(step); }
          else { animating = false; track.style.scrollSnapType = ''; }
        };
        raf = requestAnimationFrame(step);
      };

      const nearest = () => {
        const o = offsets();
        let b = 0, bd = Infinity;
        o.forEach((x, i) => { const d = Math.abs(x - track.scrollLeft); if (d < bd) { bd = d; b = i; } });
        return b;
      };
      const goTo = (i) => { index = clamp(i); animateTo(offsets()[index]); };

      /* drag, locked to a single slide */
      let down = false, startX = 0, startScroll = 0, startIndex = 0, moved = 0;

      track.addEventListener('pointerdown', (e) => {
        if (e.pointerType === 'touch') return;
        cancelAnimationFrame(raf); animating = false;
        down = true; moved = 0;
        startX = e.clientX; startScroll = track.scrollLeft;
        startIndex = nearest(); index = startIndex;
        track.classList.add('is-dragging');
        track.style.scrollSnapType = 'none';
        try { track.setPointerCapture(e.pointerId); } catch (_) {}
      });

      track.addEventListener('pointermove', (e) => {
        if (!down) return;
        const dx = e.clientX - startX;
        moved = Math.max(moved, Math.abs(dx));
        const o  = offsets();
        const lo = o[clamp(startIndex - 1)];   // never travel further than
        const hi = o[clamp(startIndex + 1)];   // one slide either way
        track.scrollLeft = Math.max(lo, Math.min(hi, startScroll - dx));
        e.preventDefault();
      });

      const endDrag = (e) => {
        if (!down) return;
        down = false;
        track.classList.remove('is-dragging');
        try { track.releasePointerCapture(e.pointerId); } catch (_) {}
        const dx = e.clientX - startX;
        const cw = cards()[startIndex] ? cards()[startIndex].offsetWidth : 300;
        const threshold = Math.min(90, cw * 0.2);
        let target = startIndex;
        if (dx <= -threshold) target = startIndex + 1;
        else if (dx >= threshold) target = startIndex - 1;
        goTo(target);
      };
      track.addEventListener('pointerup', endDrag);
      track.addEventListener('pointercancel', endDrag);

      track.addEventListener('click', (e) => {
        if (moved > 5) { e.preventDefault(); e.stopPropagation(); }
      }, true);
      track.addEventListener('dragstart', (e) => e.preventDefault());

      /* keep index honest after a native touch swipe */
      let settle = null;
      track.addEventListener('scroll', () => {
        if (down || animating) return;
        clearTimeout(settle);
        settle = setTimeout(() => { index = nearest(); }, 120);
      }, { passive: true });

      /* autoplay, one slide at a time */
      let paused = false, visible = true;
      const tick = () => {
        if (paused || down || animating || document.hidden || !visible) return;
        const n = cards().length;
        if (n > 1) goTo((nearest() + 1) % n);
      };
      if (!reduce) setInterval(tick, DELAY);

      track.addEventListener('pointerenter', () => { paused = true; });
      track.addEventListener('pointerleave', () => { paused = false; });
      track.addEventListener('focusin',  () => { paused = true; });
      track.addEventListener('focusout', () => { paused = false; });

      new IntersectionObserver(([en]) => { visible = en.isIntersecting; }, { threshold: 0.2 }).observe(track);
    };

    const scan = () => document.querySelectorAll('.promo-carousel-track').forEach(init);
    scan();
    new MutationObserver(scan).observe(document.body, { childList: true, subtree: true });
  })();





// PDP select size
document.addEventListener("DOMContentLoaded", function () {
  const variantPicker = document.querySelector("variant-picker");
  if (!variantPicker) return;

  const mainFormId = variantPicker.getAttribute('form-id');
  const mainForm = document.getElementById(mainFormId) || document.querySelector('form[action="/cart/add"]');

  variantPicker.querySelectorAll('input[type="radio"]').forEach(input => {
    input.checked = false;
    input.removeAttribute('checked');
  });

  variantPicker.querySelectorAll('.block-swatch, .color-swatch').forEach(el => {
    el.classList.remove('is-selected');
  });

  variantPicker.querySelectorAll('.variant-current-value').forEach(el => {
    el.innerText = '';
  });

  if (mainForm) {
    const variantInput = mainForm.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = '';
      variantInput.removeAttribute('value');
    }
  }

  const buyNowBtn = document.querySelector('.shopify-payment-button__button, [data-shopify="payment-button"] button, #dynamic-checkout-cart button');

  const selectSizeBtn = document.createElement('button');
  selectSizeBtn.type = 'button';
  selectSizeBtn.id = 'select-size-fake-btn';
  selectSizeBtn.innerText = 'Select a Size';

  if (buyNowBtn) {
    const buyNowWrapper = buyNowBtn.closest('[data-shopify="payment-button"]') || buyNowBtn.parentElement;

    const buyNowClasses = buyNowBtn.className;
    selectSizeBtn.className = buyNowClasses;

    selectSizeBtn.style.cssText = 'display: block; width: 100%; margin-top: 0;';

    buyNowWrapper.insertAdjacentElement('afterend', selectSizeBtn);

    buyNowWrapper.style.display = 'none';
  }

  function getSizeFieldset() {
    return [...variantPicker.querySelectorAll('fieldset.variant-picker__option')].find(fieldset => {
      const legend = fieldset.querySelector('legend');
      return legend && legend.innerText.toLowerCase().includes('size');
    });
  }

  function isSizeSelected() {
    const sizeFieldset = getSizeFieldset();
    if (!sizeFieldset) return true; 
    const sizeRadios = sizeFieldset.querySelectorAll('input[type="radio"]');
    return [...sizeRadios].some(r => r.checked);
  }

  function showSizeValidation() {
    const sizeFieldset = getSizeFieldset();
    if (!sizeFieldset) return;
    
    const currentValueEl = sizeFieldset.querySelector('.variant-current-value');
    if (currentValueEl) {
      currentValueEl.innerText = 'Please select a size';
      currentValueEl.style.color = 'white';
      currentValueEl.style.backgroundColor = 'red';
      currentValueEl.style.fontSize = '12px';
      currentValueEl.style.fontWeight = '600';
      currentValueEl.style.padding = '1px 5px';
      currentValueEl.style.borderRadius = '3px';
    }
    
    variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function clearSizeValidation() {
    const sizeFieldset = getSizeFieldset();
    if (!sizeFieldset) return;
    const currentValueEl = sizeFieldset.querySelector('.variant-current-value');
    if (currentValueEl) {
      currentValueEl.innerText = '';
      currentValueEl.style.color = '';
      currentValueEl.style.backgroundColor = '';
      currentValueEl.style.fontSize = '';
      currentValueEl.style.fontWeight = '';
      currentValueEl.style.padding = '';
    }
  }

  selectSizeBtn.addEventListener('click', function () {
    showSizeValidation();
  });

  document.addEventListener('click', function (e) {
    const isAtcButton = e.target.closest('[name="add"]') || 
                        e.target.closest('button[type="submit"]') || 
                        e.target.closest('.product-sticky-bar button[type="submit"]');

    if (isAtcButton) {
      if (!isSizeSelected()) {
        e.preventDefault();
        e.stopPropagation();
        showSizeValidation();
      }
    }
  }, true);

  variantPicker.querySelectorAll('input[type="radio"]').forEach(input => {
    input.addEventListener('change', function () {
      clearSizeValidation();

      if (buyNowBtn) {
        const buyNowWrapper = buyNowBtn.closest('[data-shopify="payment-button"]') || buyNowBtn.parentElement;

        if (isSizeSelected()) {
          buyNowWrapper.style.display = '';
          selectSizeBtn.style.display = 'none';
        } else {
          buyNowWrapper.style.display = 'none';
          selectSizeBtn.style.display = 'block';
        }
      }
    });
  });
});

function initQuickBuyModal(modal) {
  const variantPicker = modal.querySelector('variant-picker');
  if (!variantPicker) return;

  const formId = variantPicker.getAttribute('form-id');
  const form = document.getElementById(formId) || modal.querySelector('form[action="/cart/add"]');

  variantPicker.querySelectorAll('input[type="radio"]').forEach(input => {
    input.checked = false;
    input.removeAttribute('checked');
  });

  variantPicker.querySelectorAll('.block-swatch, .color-swatch').forEach(el => {
    el.classList.remove('is-selected');
  });

  variantPicker.querySelectorAll('.variant-current-value').forEach(el => {
    el.innerText = '';
  });

  if (form) {
    const variantInput = form.querySelector('input[name="id"]');
    if (variantInput) {
      variantInput.value = '';
      variantInput.removeAttribute('value');
    }
  }

  const buyNowBtn = modal.querySelector('.shopify-payment-button__button, [data-shopify="payment-button"] button, #dynamic-checkout-cart button');

  const selectSizeBtn = document.createElement('button');
  selectSizeBtn.type = 'button';
  selectSizeBtn.className = 'qb-select-size-fake-btn';
  selectSizeBtn.innerText = 'Select a Size';

  if (buyNowBtn) {
    const buyNowWrapper = buyNowBtn.closest('[data-shopify="payment-button"]') || buyNowBtn.parentElement;

    selectSizeBtn.className = buyNowBtn.className + ' qb-select-size-fake-btn';
    selectSizeBtn.style.cssText = 'display: block; width: 100%; margin-top: 0; cursor: pointer;';

    buyNowWrapper.insertAdjacentElement('afterend', selectSizeBtn);

    buyNowWrapper.style.display = 'none';
  }

  function getQBSizeFieldset() {
    return [...variantPicker.querySelectorAll('fieldset.variant-picker__option')].find(fieldset => {
      const legend = fieldset.querySelector('legend');
      return legend && legend.innerText.toLowerCase().includes('size');
    });
  }

  function isQBSizeSelected() {
    const sizeFieldset = getQBSizeFieldset();
    if (!sizeFieldset) return true;
    const sizeRadios = sizeFieldset.querySelectorAll('input[type="radio"]');
    return [...sizeRadios].some(r => r.checked);
  }

  function showQBSizeValidation() {
    const sizeFieldset = getQBSizeFieldset();
    if (!sizeFieldset) return;
    const currentValueEl = sizeFieldset.querySelector('.variant-current-value');
    if (currentValueEl) {
      currentValueEl.innerText = 'Please select a size';
      currentValueEl.style.color = 'white';
      currentValueEl.style.backgroundColor = 'red';
      currentValueEl.style.fontSize = '12px';
      currentValueEl.style.fontWeight = '600';
      currentValueEl.style.padding = '1px 5px';
      currentValueEl.style.borderRadius = '3px';
    }
  }

  function clearQBSizeValidation() {
    const sizeFieldset = getQBSizeFieldset();
    if (!sizeFieldset) return;
    const currentValueEl = sizeFieldset.querySelector('.variant-current-value');
    if (currentValueEl) {
      currentValueEl.innerText = '';
      currentValueEl.style.color = '';
      currentValueEl.style.fontSize = '';
      currentValueEl.style.fontWeight = '';
      currentValueEl.style.backgroundColor = '';
      currentValueEl.style.padding = '';
      currentValueEl.style.borderRadius = '';
    }
  }

  selectSizeBtn.addEventListener('click', function () {
    showQBSizeValidation();
    variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });

  if (form) {
    const atcBtn = form.querySelector('[name="add"], [type="submit"]');
    if (atcBtn) {
      atcBtn.addEventListener('click', function (e) {
        if (!isQBSizeSelected()) {
          e.preventDefault();
          e.stopPropagation();
          showQBSizeValidation();
        }
      });
    }
  }

  variantPicker.querySelectorAll('input[type="radio"]').forEach(input => {
    input.addEventListener('change', function () {
      clearQBSizeValidation();

      if (buyNowBtn) {
        const buyNowWrapper = buyNowBtn.closest('[data-shopify="payment-button"]') || buyNowBtn.parentElement;

        if (isQBSizeSelected()) {
          buyNowWrapper.style.display = '';
          selectSizeBtn.style.display = 'none';
        } else {
          buyNowWrapper.style.display = 'none';
          selectSizeBtn.style.display = 'block';
        }
      }
    });
  });
}

const quickBuyObserver = new MutationObserver(function (mutations) {
  mutations.forEach(function (mutation) {
    mutation.addedNodes.forEach(function (node) {
      if (node.nodeType !== 1) return;

      const modal = node.matches && node.matches('quick-buy-modal')
        ? node
        : node.querySelector && node.querySelector('quick-buy-modal');

      if (modal) {
        setTimeout(() => initQuickBuyModal(modal), 150);
      }
    });
  });
});

quickBuyObserver.observe(document.body, { childList: true, subtree: true });


// // Product Sticky Bar - Vanilla JS (no jQuery)
document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.querySelector('.product-sticky-bar');
  if (!stickyBar) return;

  const footer = document.querySelector('footer');
  if (!footer) return;

  const isDesktop = window.innerWidth > 1000;
  const threshold = isDesktop ? 500 : 0;

  window.addEventListener('scroll', function () {
    const scrollTop = window.scrollY;
    const footerOffsetTop = footer.getBoundingClientRect().top + window.scrollY;
    const windowHeight = window.innerHeight;

    if (scrollTop > threshold) {
      stickyBar.classList.add('is-visible');
    } else {
      stickyBar.classList.remove('is-visible');
    }

    if (scrollTop + windowHeight >= footerOffsetTop) {
      stickyBar.classList.remove('is-visible');
    }
  }, { passive: true });
});

document.addEventListener('DOMContentLoaded', function () {
  const stickyBar = document.querySelector('.product-sticky-bar');
  if (!stickyBar) return;

  const variantPicker = document.querySelector('variant-picker');
  const formId = variantPicker ? variantPicker.getAttribute('form-id') : null;
  const mainForm = formId
    ? document.getElementById(formId)
    : document.querySelector('form[action="/cart/add"]');

  const stickyFormId = stickyBar.getAttribute('form');
  const stickyForm = stickyFormId ? document.forms[stickyFormId] : null;
  const stickyVariantInput = stickyForm ? stickyForm.querySelector('input[name="id"]') : null;
  const errorMsg = document.getElementById('select_size_error-message');
  const selectSizeTrigger = document.getElementById('sticky-select-size-trigger');
  const selectSizeDiv = stickyBar.querySelector('.select-a-size-btn');
  const buyButtonsDiv = stickyBar.querySelector('.buy-buttons');

  function isSizeSelected() {
    if (!variantPicker) return true;
    const sizeFieldset = [...variantPicker.querySelectorAll('fieldset.variant-picker__option')].find(f => {
      const legend = f.querySelector('legend');
      return legend && legend.innerText.toLowerCase().includes('size');
    });
    if (!sizeFieldset) return true;
    return [...sizeFieldset.querySelectorAll('input[type="radio"]')].some(r => r.checked);
  }

  function updateStickyState() {
    const selected = isSizeSelected();

    if (stickyVariantInput && mainForm) {
      const mainVariantInput = mainForm.querySelector('input[name="id"]');
      stickyVariantInput.value = selected && mainVariantInput ? mainVariantInput.value : '';
    }
    if (selectSizeDiv) selectSizeDiv.style.display = selected ? 'none' : '';
    if (buyButtonsDiv) {
      const submitBtn = buyButtonsDiv.querySelector('[type="submit"][name="add"]');
      if (submitBtn) submitBtn.closest('buy-buttons') && (buyButtonsDiv.style.opacity = selected ? '1' : '0.4');
    }

    if (errorMsg) errorMsg.style.display = 'none';
  }

  updateStickyState();
  if (variantPicker) {
    variantPicker.addEventListener('change', updateStickyState);
  }
  if (selectSizeTrigger) {
    selectSizeTrigger.addEventListener('click', function () {
      if (variantPicker) {
        variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      if (errorMsg) {
        errorMsg.style.display = '';
        setTimeout(() => { errorMsg.style.display = 'none'; }, 3000);
      }
    });
  }

document.addEventListener('click', function (e) {
  const stickyBarEl = document.querySelector('.product-sticky-bar');
  if (!stickyBarEl) return;
  const clickedBtn = e.target.closest('.product-sticky-bar [type="submit"]');
  if (!clickedBtn) return;
  if (clickedBtn.closest('.select-a-size-btn')) return;
  if (!isSizeSelected()) {
    e.preventDefault();
    e.stopImmediatePropagation();
    if (errorMsg) errorMsg.style.display = '';
    if (variantPicker) variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
    setTimeout(() => { if (errorMsg) errorMsg.style.display = 'none'; }, 3000);
  }
}, true);

});

// PDP thumnail

document.addEventListener('DOMContentLoaded', () => {
  const gallery = document.querySelector('.product-gallery__thumbnail-list');
  if (!gallery) return;

  const scroller = gallery.querySelector('.product-gallery__thumbnail-scroller');
  const prevBtn = gallery.querySelector('.thumbnail-arrow--prev');
  const nextBtn = gallery.querySelector('.thumbnail-arrow--next');

  if (!scroller || !prevBtn || !nextBtn) return;

  const scrollAmount = 200;

  prevBtn.addEventListener('click', () => {
    scroller.scrollBy({
      left: -scrollAmount,
      behavior: 'smooth'
    });
  });

  nextBtn.addEventListener('click', () => {
    scroller.scrollBy({
      left: scrollAmount,
      behavior: 'smooth'
    });
  });
});


// Accessories Product

document.addEventListener('click', function (event) {
  const button = event.target.closest('[data-collection-quick-add]');
  if (!button) return;

  const form = button.closest('form[action*="/cart/add"]');
  if (!form) return;

  event.preventDefault();

  // Use GoKwik directly when its side cart is active.
  if (typeof window.addItemtoCartFromForm === 'function') {
    window.addItemtoCartFromForm({ target: button });
    return;
  }

  // Shopify native fallback.
  if (typeof form.requestSubmit === 'function') {
    form.requestSubmit();
  }
});
